let timeoutID: number;

export function debounce(fn: Function, duration: number, ...args: any) {
  clearTimeout(timeoutID);
  timeoutID = window.setTimeout(() => {
    fn.apply(null, args);
  }, duration);
}
